/**
 * 批量修改用户类型
 */
import React from 'react';
import {Button, Select} from "antd";
import CmModal from "../../../../components/CmModal/CmModal";
import {message} from "../../../../view/sysManagement/utils/sysManagementUtils";
import BaseComponent from "../../../../base/BaseComponent";

const {Option} = Select;

export default class BatchUpdateUserType extends BaseComponent {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            batchUpdateUserTypeVisible: false,
            tsUserList: props.tsUserList,
            type: null
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            tsUserList: nextProps.tsUserList
        })
    }

    batchUpdateHandle = () => {
        const {tsUserList} = this.state;
        if (!tsUserList.length) {
            message.warn('请选择用户！');
            return false
        }
        if (tsUserList.length) {
            this.setState({
                batchUpdateUserTypeVisible: true,
                type: null
            });
        }
    };

    handleCancel = () => {
        this.setState({
            batchUpdateUserTypeVisible: false
        });
    };

    /**
     * 批量修改用户类型
     */
    batchUpdate = () => {
        if (!this.state.type) {
            message.warn("请选择用户类型！");
            return;
        }
        let ids = [];
        let {tsUserList} = this.state;
        tsUserList.forEach(function (item) {
            ids.push(item.id);
        });
        let params = {
            ids,
            userType: this.state.type
        };
        this.request({
            url: "/cm-sites-mmp/rmUser/batchUpdate",
            body: params,
            method: "post",
            contentType: "json",
            callBack: (res) => {
                if (res) {
                    message.success("用户修改类型成功");
                    this.props.refreshList();
                    this.handleCancel();
                }
            }
        });
    };

    render() {
        let options = [{
            key: "1",
            value: 1,
            title: "外部人员"
        },
            {
                key: "2",
                value: 2,
                title: "内部人员"
            },
            {
                key: "3",
                value: 3,
                title: "内部管理"
            }];
        return (
            <>
                <Button style={{marginRight: "20px"}} onClick={this.batchUpdateHandle}>
                    批量修改用户类型
                </Button>
                {/*批量修改用户类型弹窗*/}
                <CmModal
                    handleOk={this.batchUpdate}
                    handleCancel={this.handleCancel}
                    visible={this.state.batchUpdateUserTypeVisible}
                    title="批量修改用户类型"
                    width={500}
                >
                    <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <div style={{marginRight: "20px"}}><span style={{color: "red"}}>*</span>用户类型：</div>
                        <div>
                            <Select
                                placeholder={"请选择用户类型"}
                                allowClear
                                style={{width: 250}}
                                value={this.state.type || undefined}
                                onChange={(value) => {
                                    this.setState({
                                        type: value
                                    })
                                }}>
                                {options.length > 0 && options.map(i => {
                                    return <Option key={i.key} value={i.value}>{i.title}</Option>
                                })}
                            </Select>
                        </div>
                    </div>
                </CmModal>
            </>
        )
    }
}